/* eslint-disable react/prop-types */
import PillNavs from 'components/Products/PillNavs'
import React, { useState } from 'react'
import { TabContent, TabPane } from 'reactstrap'
import { useLocation } from 'react-router-dom'

const Brand = () => (
  <>
    <p>
      Brand Specific foods are identified{' '}
      <i>by brand only or by brand and product name</i> in{' '}
      <a
        href="https://www.cdph.ca.gov/Programs/CFH/DWICSN/Pages/LawsandRegulations.aspx"
        target="_blank"
        rel="noopener noreferrer"
      >
        WIC Bulletin Regulations (WBR)
      </a>{' '}
      and the{' '}
      <a
        href="https://www.cdph.ca.gov/Programs/CFH/DWICSN/CDPH Document Library/WICFoods/ShoppingGuide-EN-ADA-4.19%20rev%205.19%20FINAL.pdf"
        target="_blank"
        rel="noopener noreferrer"
      >
        WIC Authorized Food List Shopping Guide (Shopping Guide)
      </a>
      . Foods fall into this group when federal regulations outline specific
      nutritional criteria that make it difficult for participants to identify
      authorization status on their own.
    </p>
    <p>
      Brand Specific foods include Breakfast Cereal, Soy, Tofu, Infant Cereal,
      Corn Tortillas, Whole Wheat Tortillas, Whole Wheat Pasta, and Yogurt.
    </p>
    <p>
      Brand Specific foods may only be submitted by manufacturers during a
      CDPH/WIC Brand Specific Request for Information (RFI) open submission
      period.{' '}
      <b>
        CDPH/WIC is not currently soliciting submissions for Brand Specific
        foods
      </b>
      .
    </p>
    <p>
      <u>Infant Fruits and Vegetables</u> and <u>Infant Meats</u> are the two
      food categories that are identified by brand only in{' '}
      <a
        href="https://www.cdph.ca.gov/Programs/CFH/DWICSN/Pages/LawsandRegulations.aspx"
        target="_blank"
        rel="noopener noreferrer"
      >
        WBR
      </a>{' '}
      and the{' '}
      <a
        href="https://www.cdph.ca.gov/Programs/CFH/DWICSN/CDPH Document Library/WICFoods/ShoppingGuide-EN-ADA-4.19%20rev%205.19%20FINAL.pdf"
        target="_blank"
        rel="noopener noreferrer"
      >
        Shopping Guide
      </a>
      . Any product made by these specified brands that meets the requirements
      may be submitted for inclusion in the{' '}
      <a
        href="https://www.cdph.ca.gov/Programs/CFH/DWICSN/Pages/WICFoods/CAWICAPL.aspx"
        target="_blank"
        rel="noopener noreferrer"
      >
        California APL
      </a>{' '}
      on a continuous basis. Manufacturers, vendors, and participants are
      welcome to submit new products for the specified brands as they become
      available.
    </p>
  </>
)

const NonBrand = () => (
  <>
    <p>
      Any Brand foods are products in food categories not specified by brand
      and/or product name in{' '}
      <a
        href="https://www.cdph.ca.gov/Programs/CFH/DWICSN/Pages/LawsandRegulations.aspx"
        target="_blank"
        rel="noopener noreferrer"
      >
        WIC Bulletin Regulations (WBR)
      </a>{' '}
      and the{' '}
      <a
        href="https://www.cdph.ca.gov/Programs/CFH/DWICSN/CDPH Document Library/WICFoods/ShoppingGuide-EN-ADA-4.19%20rev%205.19%20FINAL.pdf"
        target="_blank"
        rel="noopener noreferrer"
      >
        WIC Authorized Food List Shopping Guide (Shopping Guide)
      </a>
      . The authorization criteria for these foods are listed in WBR and the
      Shopping Guide.
    </p>
    <p>
      Any Brand food products may be submitted for consideration on a continuous
      basis and at any time except during the open submission period of a Brand
      Specific Request for Information (RFI).
    </p>
  </>
)

const PriorToSub = () => (
  <>
    <p className="font-weight-bold ml-4">
      <span className="text-danger">IMPORTANT UPDATE:</span> The requirements
      for WIC foods will be changing on April 13, 2026. CDPH/WIC is now
      accepting submissions for UPCs in the Any Brand food categories that meet
      the new requirements listed in{' '}
      <a
        href="https://www.cdph.ca.gov/Programs/CFH/DWICSN/CDPH%20Document%20Library/LawsandRegulations/RegulatoryBulletins/RegulatoryBulletin2025-01.pdf"
        target="_blank"
        rel="noopener noreferrer"
      >
        Regulatory Bulletin 2025-01
      </a>
      . Any UPCs approved will be available on the California Authorized Product
      List (APL) beginning April 13, 2026.
      <br />
      <br />
      <p>
        The links to the new Shopping Guide will be updated at a later date.
      </p>
      <br />
    </p>
    <ol>
      <li className="pb-2">
        Verify that each product meets the requirements listed in{' '}
        <a
          href="http://www.ecfr.gov/cgi-bin/text-idx?SID=07f7e6cf090029dec3bd84dc1a7d7253&node=pt7.4.246&rgn=div5#se7.4.246_110"
          target="_blank"
          rel="noopener noreferrer"
        >
          federal WIC regulations.
        </a>
      </li>
      <li className="pb-2">
        Verify that each product meets the requirements listed in{' '}
        <a
          href="https://www.cdph.ca.gov/Programs/CFH/DWICSN/Pages/LawsandRegulations.aspx"
          target="_blank"
          rel="noopener noreferrer"
        >
          WIC Bulletin Regulations (WBR)
        </a>{' '}
        and the{' '}
        <a
          href="https://www.cdph.ca.gov/Programs/CFH/DWICSN/CDPH Document Library/WICFoods/ShoppingGuide-EN-ADA-4.19%20rev%205.19%20FINAL.pdf"
          target="_blank"
          rel="noopener noreferrer"
        >
          WIC Authorized Food List Shopping Guide (Shopping Guide)
        </a>
        .
      </li>
      <li className="pb-2">
        Review{' '}
        <a
          href="https://www.fns.usda.gov/wic/information-food-manufacturers-regarding-wic-food-packages"
          target="_blank"
          rel="noopener noreferrer"
        >
          USDA’s Information for Food Manufacturers
        </a>
        .
      </li>
      <li>
        Review the {''}
        <a
          href="https://www.cdph.ca.gov/Programs/CFH/DWICSN/Pages/WICFoods/CAWICAPL.aspx"
          target="_blank"
          rel="noopener noreferrer"
        >
          California Authorized Product List (APL)
        </a>{' '}
        to verify the product submission will not be a duplicate.
      </li>
    </ol>
    <p className="font-weight-bold ml-4">
      <span className="text-danger">Note:</span> Do not submit UPCs in APLSS for
      fresh fruits and vegetables. Rather, WIC authorized vendors must map these
      products by UPC to a Price Look-Up (PLU) code. Please refer to the{' '}
      <a
        href="https://www.cdph.ca.gov/Programs/CFH/DWICSN/Pages/WICFoods/CAWICAPL.aspx"
        target="_blank"
        rel="noopener noreferrer"
      >
        California APL
      </a>{' '}
      for a list of PLUs.
    </p>
  </>
)

const Reminder = () => (
  <>
    <ul>
      <li className="pb-2">
        WIC participants using the California WIC Card can only buy products
        that are listed by UPC in the{' '}
        <a
          href="https://www.cdph.ca.gov/Programs/CFH/DWICSN/Pages/WICFoods/CAWICAPL.aspx"
          target="_blank"
          rel="noopener noreferrer"
        >
          California Authorized Product List (APL)
        </a>
        .
      </li>
      <li className="pb-2">
        <span className="font-weight-bold">To all submitters</span>: You will
        receive an email from{' '}
        <a href="mailto:WICfoods@cdph.ca.gov">WICFoods@cdph.ca.gov</a> if your
        product is deemed not authorized. If a product is authorized, it will be
        added to the{' '}
        <a
          href="https://www.cdph.ca.gov/Programs/CFH/DWICSN/Pages/WICFoods/CAWICAPL.aspx"
          target="_blank"
          rel="noopener noreferrer"
        >
          California APL
        </a>{' '}
        as soon as possible; you will <u>not</u> receive an email.
      </li>
      <li>
        <span className="font-weight-bold text-danger">
          To all food manufacturers
        </span>
        : If a product is submitted by a food manufacturer&apos;s employee or
        agent, the manufacturer must notify CDPH/WIC <u>in writing</u> of all
        product changes and the effective date of the changes. Product changes
        include, but are not limited to, changes in container size, ingredients,
        product name, or discontinuance of a product.
      </li>
    </ul>
    <ul style={{ listStyleType: 'none' }}>
      <li>
        Submit notification of these changes to{' '}
        <a href="mailto:WICfoods@cdph.ca.gov">WICFoods@cdph.ca.gov</a>
      </li>
      .
    </ul>
  </>
)

const SubmittersMessage = (
  {
    priorToSub = <PriorToSub />,
    importantReminder = <Reminder />,
    brandSpecific = <Brand />,
    nonBrand = <NonBrand />,
    initial = 0,
  },
  props
) => {
  const exemptURL = ['/submission/dashboard', '/auth/login']

  exemptURL.includes(useLocation().pathname) ? (initial = 0) : (initial = 2)

  const NavsInfo = [
    {
      name: 'Before You Submit',
      component: priorToSub,
    },
    {
      name: 'Important Reminders',
      component: importantReminder,
    },
    {
      name: 'Brand Specific Foods',
      component: brandSpecific,
    },
    {
      name: 'Any Brand Foods',
      component: nonBrand,
    },
  ]

  const [currentNav, setCurrentNav] = useState(NavsInfo[initial].name)

  return (
    <>
      <PillNavs
        navs={NavsInfo}
        startNav={currentNav}
        setCurrentNav={setCurrentNav}
      />
      <TabContent
        className="tab-space tab-subcategories"
        activeTab={currentNav}
      >
        {NavsInfo.map(nav => (
          <TabPane
            key={nav.name}
            tabId={nav.name}
            id={nav.name
              .trim()
              .split(/ +/)
              .join('')}
          >
            {nav.component}
          </TabPane>
        ))}
      </TabContent>
    </>
  )
}

export default SubmittersMessage
